import { Dropdown } from "primereact/dropdown";
import { MultiSelect } from "primereact/multiselect";
import { useEffect, useMemo } from "react";
import PanelHeaderTemplate from "../PanelHeadeTemplate/PanelHeaderTemplate";
import projectStore from "../../../Store/projectStore";
import _ from "underscore";

const CommonFilterDropdown = ({ fields, filterValues, setFilterValues }) => {
    const { options, getFilterOptions } = projectStore();
    const getOptionLabels = (key) => {
        switch (key) {
            case "projects":
                return "project_name";
            case "users":
                return "user_display_name";
            case "project_leads":
                return "user_display_name";
            case "project_role":
                return "project_role_name";
            case "all_users":
                return "user_display_name";
            case "issue_type":
                return "issue_type_name";
            case "project_glance_category":
                return "client_name";
            case "project_status":
                return "project_status_name";
            case "client":
                return "client_name";
            case "project_priority":
                return "project_priority_name"
            case "project_portfolio":
                return "project_portfolio_name";
            case "user_technologies":
                return "primary_skill_1";
            case "user_status":
                return "user_status_name";
            case "attendance_type":
                return "attendance_type_name";
            case "project_request_type":
                return "request_type_name"
            case "project_category":
                return "client_name";
            case "technology":
                return "technology_name";
            case "visitor_name":
                return "visitor_name";
            case "gatepass_leave_types":
                return "leave_type_name";
            case "business_units":
                return "business_unit";
            case "sub_business_units":
                return "sub_business_unit";
            case "departments":
                return "attribute_unit_desc"
            case "log_environments":
                return "environment_name";
            case "log_type":
                return "log_type_name";
            case "build_type":
                return "build_type_name";
            case "survey_type":
                return "survey_type_name";
            case "question_category":
                return "question_category_name";
            case "day_calendar_groups":
                return "group_name"
            case "evaluator_status":
                return "status_name";
            case "locations":
                return "location";
            case "asset_status":
                return "status_name";
            case "branch":
                return "branch_name";
            case "asset_make":
                return "asset_make_name";
            case "assignee":
                return "user_display_name";
            case "issue_status":
                return "status_name";
            case "user_tags":
                return "tag_name";
            case "assets_card_view_options":
                return "card_view_name";
            case "assets_volumn_breakdown_options":
                return "volumn_breakdown_name";
            case "user_category":
                return "user_category_name"
            case "precision_lead":
                return "user_display_name";
            case "sprint":
                return "sprint_name";
            case "issueType":
                return "issue_type_name";
            case "subProject":
                return "project_module_name";
            case "reporters":
                return "user_display_name";
        }
    }

    const fieldsSerializedKey = useMemo(() => {
        return fields?.map(f => f?.key).sort().join(",") || "";
    }, [fields]);

    useEffect(() => {
        if (!fields || fields.length === 0) return;

        const computedAutopopulateKeys = fields
            ?.filter(item => item && !item?.options)
            ?.map(item => ({
                ...item,
                optionLabel: getOptionLabels(item?.key)
            })) || [];
        getFilterOptions(computedAutopopulateKeys);

    }, [fieldsSerializedKey]);


    useEffect(() => {
        if (options?.selectedLead?.user_code) {
            const projectLead = fields?.find(f => f?.key === "project_leads" || f?.key === "precision_lead");
            const isDropdown = projectLead?.type === "dropdown";
            !projectLead?.restrictDefault && setFilterValues((prev) => ({ ...prev, [projectLead?.key]: isDropdown ? options?.selectedLead : [options?.selectedLead], apiCall: true }));
        }
        if (options?.selectedUnit?.group_id) {
            const unitField = fields?.find(f => f?.key === "day_calendar_groups");
            const isDropdown = unitField?.type === "dropdown";
            setFilterValues((prev) => ({ ...prev, day_calendar_groups: isDropdown ? options.selectedUnit : [options.selectedUnit], apiCall: true }));
        }
        else {
            options?.apiCall && setFilterValues((prev) => ({ ...prev, apiCall: true }));
        }
    }, [options?.selectedLead, options?.apiCall, options?.selectedUnit]);


    useEffect(() => {
        setFilterValues((prev) => {
            let updates = {};
            if (!_.isEmpty(prev?.projects) && !_.isEmpty(prev?.client)) {
                const selectedClientIds = _.pluck(prev.client, "client_id").map(id => String(id));
                const validProjects = _.filter(prev.projects, p => {
                    const projectClientList = p.client_ids ? String(p.client_ids).split(',').map(id => id.trim()) : [];
                    return _.intersection(selectedClientIds, projectClientList).length > 0;
                });
                if (!_.isEqual(validProjects, prev.projects)) {
                    updates.projects = validProjects;
                }
            }
            if (!_.isEmpty(prev?.users) && !_.isEmpty(prev?.projects)) {
                const selectedProjectIds = _.pluck(prev.projects, "project_id");
                const validUsers = _.filter(prev.users, u => selectedProjectIds.includes(u.primary_project_id));
                if (!_.isEqual(validUsers, prev.users)) {
                    updates.users = validUsers;
                }
            }

            if (!_.isEmpty(prev?.day_calendar_groups)) {
                const selectedUnitIds = _.pluck(prev.day_calendar_groups, "group_id");
                if (!_.isEmpty(prev?.users)) {
                    const validUsers = _.filter(prev.users, u => selectedUnitIds.includes(u.group_id));
                    if (!_.isEqual(validUsers, prev.users)) updates.users = validUsers;
                }

                if (!_.isEmpty(prev?.project_leads)) {
                    const projectLead = fields?.find(f => f.key === "project_leads");
                    const isDropdown = projectLead?.type === "dropdown";

                    const validLeads = _.filter(isDropdown ? [prev.project_leads] : prev.project_leads, l => selectedUnitIds.includes(l.group_id));
                    if (!_.isEqual(validLeads, prev.project_leads)) updates.project_leads = isDropdown ? validLeads[0] : validLeads;
                }
            }

            return _.isEmpty(updates) ? prev : { ...prev, ...updates };
        });
    }, [filterValues?.projects, filterValues?.client, filterValues?.day_calendar_groups]);


    return (
        <div className="row g-3 w-100 mx-0" >
            {fields?.map(item => {
                if (!item || item.isHide) return null;

                const Component = item?.type === "dropdown" ? Dropdown : MultiSelect;
                const placeholder = item?.label ? item?.label : item?.key?.split("_")?.map((val) => val?.charAt(0).toUpperCase() + val?.slice(1))?.join(" ");

                return (
                    <div key={item?.key} className={`${item?.widthClass ? item?.widthClass : `col-md-${item?.col || 6} col-12`} px-1`}>
                        <Component
                            className="sk-multiselect"
                            placeholder={placeholder}
                            title={placeholder}
                            value={filterValues?.[item?.key] || null}
                            onChange={(e) => setFilterValues((prev) => ({ ...prev, [item?.key]: e.target.value, isChange: true, apiCall: (item?.type === "dropdown" && !e.target?.value) }))}
                            onHide={() => { if (filterValues?.isChange) { setFilterValues((prev) => ({ ...prev, apiCall: true, isChange: false })); if (item?.onHide) { item?.onHide(); } } }}
                            options={(() => {
                                if (item?.options) return item?.options;
                                let currentOptions = options?.[item?.key] || [];
                                if (item?.key === "projects" && !_.isEmpty(filterValues?.client)) {
                                    const selectedClientIds = _.pluck(filterValues.client, "client_id").map(id => String(id));

                                    currentOptions = _.filter(currentOptions, p => {
                                        const projectClientList = p.client_ids ? String(p.client_ids).split(',').map(id => id.trim()) : [];
                                        return _.intersection(selectedClientIds, projectClientList).length > 0;
                                    });
                                }
                                if (item?.key === "users" && !_.isEmpty(filterValues?.projects)) {
                                    const selectedProjectIds = _.pluck(filterValues.projects, "project_id");
                                    currentOptions = _.filter(currentOptions, u => selectedProjectIds.includes(u.primary_project_id));
                                }

                                if ((item?.key === "users" || item?.key === "project_leads") && !_.isEmpty(filterValues?.day_calendar_groups)) {
                                    const unitIds = _.pluck(filterValues.day_calendar_groups, "group_id");
                                    currentOptions = _.filter(currentOptions, u => unitIds.includes(u.group_id));
                                }

                                if (item?.key === "users" && !_.isEmpty(_.findWhere(fields, { key: "precision_lead" }))) {
                                    currentOptions = _.filter(currentOptions, user => user?.group_name === "SRK Exports");
                                }
                                return currentOptions;
                            })()}
                            optionLabel={getOptionLabels(item?.key)}
                            optionValue={item?.optionValue}
                            showClear={item?.type === "dropdown" ? (item?.showClear ?? true) : false}
                            panelHeaderTemplate={item?.type === "dropdown" ? undefined : (opts) => PanelHeaderTemplate(opts, item?.key, filterValues?.[item?.key], () => setFilterValues((prev) => ({ ...prev, [item?.key]: [], isChange: true })))}
                            filter
                            filterInputAutoFocus
                        />
                    </div>
                );
            })}
        </div>
    );
};

export default CommonFilterDropdown;